import { useMemo } from "react";
import { useSelector, shallowEqual } from "react-redux";
import useIsBraintreeEnabled from "@tvg/sh-lib-paws/hooks/useIsBraintreeEnabled";
import { getPmToggles } from "../utils";

/**
 * Returns the full payment-method toggle map. Braintree visibility (BTCC/BTDB)
 * resolves through the combined SGW + Amplitude gate; everything else comes
 * from the `getPmToggles` selector.
 */
export const useGetPmToggles = () => {
  const { isEnabled: isBraintreeCCEnabled } = useIsBraintreeEnabled();
  const baseToggles = useSelector(getPmToggles, shallowEqual);

  return useMemo(
    () => ({
      ...baseToggles,
      BTCC: isBraintreeCCEnabled,
      BTDB: isBraintreeCCEnabled
    }),
    [baseToggles, isBraintreeCCEnabled]
  );
};

export default useGetPmToggles;
